// React
import { useContext } from "react"

// Components
import { BaseTable, Button, Loading, TableHeader } from "components"

// Contexts
import { DataBillContext, DataContext } from "../../contexts"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Third-Party Libraries
import moment from "moment"
import { Link, useParams } from "react-router-dom"

// Utils
import { convertNumber } from "utils"
import { default_option } from "pages/Purchase/utils"

export function Payment() {
  // Hooks
  const data = useContext(DataContext)
  const { bill_id } = useParams()
  const { payment_list, bill_status } = useContext(DataBillContext)

  // Vars
  const isEnabled: boolean = data.approval_status === 4 && bill_status === "Open"

  return (
    <>
      <BaseTable>
        <TableHeader>
          <tr>
            <th rowSpan={2}>NO</th>
            <th rowSpan={2}>PAYMENT BILL ID</th>
            <th rowSpan={2}>DATE</th>
            <th rowSpan={2}>STATUS</th>
            <th rowSpan={2}>REF BILL ID#</th>
            <th rowSpan={2}>MEMO</th>
            <th colSpan={2}>PAYMENT</th>
            <th rowSpan={2}>TOTAL PAYMENT BILL</th>
            <th rowSpan={2}>ACTION</th>
          </tr>

          <tr>
            <th>DEPO</th>
            <th>PAYMENT</th>
          </tr>
        </TableHeader>

        <tbody>
          {!payment_list.length ? (
            <tr>
              <td colSpan={10}>
                <Loading errorText="No data available" />
              </td>
            </tr>
          ) : payment_list.map((item, key) => {
            // Vars
            const deposit_amount = item.deposit_amount
            const payment_amount = item.payment_amount

            return (
              <tr key={key}>
                <td className="text-center">{key + 1}</td>
                <td className="text-center">{item.trx_code}</td>
                <td className="text-center">{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                <td className="text-center">{default_option.find(i => item.approve_status.toString() === i.value)?.label}</td>
                <td className="text-center">{item.ref_bill_id}</td>
                <td>{item.memo}</td>
                <td className="text-right">{convertNumber(deposit_amount).intoCurrency}</td>
                <td className="text-right">{convertNumber(payment_amount).intoCurrency}</td>
                <td className="text-right">{convertNumber(deposit_amount + payment_amount).intoCurrency}</td>
                <td>
                  <Edit payment_bill_id={item.payment_bill_id} />
                </td>
              </tr>
            )
          })}
        </tbody>
      </BaseTable>

      <section className="flex justify-end">
        <Create
          bill_id={bill_id!}
          isEnabled={isEnabled}
        />
      </section>
    </>
  )
}

function Edit(params: {
  payment_bill_id: number
}): JSX.Element {
  // Hooks
  // const { isActive, toggle } = useToggle(false)

  return (
    <>
      <Link
        to={`/purchase/transaction/payment-bill/edit/${params.payment_bill_id}`}
      >
        <button>
          <IoSendSharp />
        </button>
      </Link>


      {/* {isActive && (
        <EditPaymentBillModal
          payment_bill_id={params.payment_bill_id.toString()}
          toggle={toggle}
        />
      )} */}
    </>
  )
}

// function Create(params: {
//   bill_id: string
//   isEnabled: boolean
// }): JSX.Element {
//   // Hooks
//   const { isActive, toggle } = useToggle(false)

//   return (
//     <>
//       <Button
//         color="primary"
//         disabled={!params.isEnabled}
//         onClick={toggle}
//       >
//         CREATE PAYMENT BILL
//       </Button>

//       {isActive && (
//         <PaymentBillModal
//           bill_id={params.bill_id}
//           toggle={toggle}
//         />
//       )}
//     </>
//   )
// }

function Create(params: {
  bill_id: string
  isEnabled: boolean
}): JSX.Element {
  return (
    <>
      <Link
        to={params.isEnabled ? `/purchase/transaction/payment-bill/${params.bill_id}` : "#"}
      >
        <Button
          color="primary"
          disabled={!params.isEnabled}
        >
          CREATE PAYMENT BILL
        </Button>
      </Link>
    </>
  )
}